import React from "react";
import {
  DOOR_STYLES,
  DOOR_SERIES,
  ESSENTIAL_DOORS,
  NATIVE_DOORS,
  PANEL_STYLES,
  ALUMICOMP_DESIGNS,
  SOLID_SHEET_DESIGNS,
  MATERIALS,
  SOLID_MATERIALS,
} from "../Constants/constants";

const DoorOptions = ({
  selectedPattern,
  selectSeries,
  selectedDesign,
  selectedPanelStyle,
  SelectedMaterial,
  handlePatternChange,
  handleSeriesChange,
  setSelectedDesign,
  handlePanelStyleChange,
  setSelectedMaterial,
  applyDoorDesign,
  selectedColor,
}) => {
  return (
    <>
      <h5>Select Your Door Style</h5>
      <div className="d-flex align-items-center mt-2">
        {DOOR_STYLES.map((pattern) => (
          <div
            key={pattern.id}
            className="d-grid selected-btn"
            onClick={() =>
              document.getElementById(`pattern-${pattern.name}`).click()
            }
            style={{ cursor: "pointer" }}
          >
            <input
              className="hidden-radio"
              type="radio"
              name="pattern"
              id={`pattern-${pattern.name}`}
              value={pattern.name}
              checked={selectedPattern === pattern.name}
              onChange={() => handlePatternChange(pattern.name)}
              style={{ width: "max-content" }}
            />
            <img
              src={pattern.img}
              alt={`pattern-${pattern.name}`}
              className="img-fluid door-img ms-3"
            />
            <label htmlFor={`pattern-${pattern.name}`}>
              {pattern.name.charAt(0).toUpperCase() + pattern.name.slice(1)}
            </label>
          </div>
        ))}
      </div>

      {/* Door Series */}
      {selectedPattern === "sectional" && (
        <>
          <h5 className="mt-3">Select Your Door Series</h5>
          <div className="d-flex align-items-center">
            {DOOR_SERIES.map((pattern) => (
              <div
                key={pattern.id}
                className="d-grid selected-btn"
                onClick={() =>
                  document.getElementById(`series-${pattern.name}`).click()
                }
                style={{ cursor: "pointer" }}
              >
                <input
                  className="hidden-radio"
                  type="radio"
                  name="series"
                  id={`series-${pattern.name}`}
                  value={pattern.name}
                  checked={selectSeries === pattern.name}
                  onChange={() => handleSeriesChange(pattern.name)}
                  style={{ width: "max-content" }}
                />
                <img
                  src={pattern.img}
                  alt={`pattern-${pattern.name}`}
                  className="img-fluid door-img ms-3"
                />
                <label htmlFor={`series-${pattern.name}`}>
                  {pattern.name.charAt(0).toUpperCase() + pattern.name.slice(1)}
                </label>
              </div>
            ))}
          </div>
        </>
      )}

      {/* Essential Door Designs */}
      {selectSeries === "Essentials" && (
        <>
          <h5 className="mt-3">Select Your Door Design</h5>
          <div className="d-flex align-items-center flex-wrap mt-2">
            {ESSENTIAL_DOORS.map((pattern) => (
              <div
                key={pattern.id}
                className="d-grid selected-btn"
                onClick={() =>
                  document.getElementById(`design-${pattern.name}`).click()
                }
                style={{ cursor: "pointer" }}
              >
                <input
                  className="hidden-radio"
                  type="radio"
                  name="design"
                  id={`design-${pattern.name}`}
                  value={pattern.name}
                  checked={selectedDesign === pattern.name}
                  onChange={() => {
                    setSelectedDesign(pattern.name);
                    applyDoorDesign(selectedColor, pattern.name);
                  }}
                  style={{ width: "max-content" }}
                />
                <img
                  src={pattern.img}
                  alt={`pattern-${pattern.name}`}
                  className="img-fluid door-img ms-3"
                />
                <label htmlFor={`design-${pattern.name}`}>
                  {pattern.name.charAt(0).toUpperCase() + pattern.name.slice(1)}
                </label>
              </div>
            ))}
          </div>
        </>
      )}

      {/* Native Door Designs */}
      {selectSeries === "Native" && (
        <>
          <h5 className="mt-3">Select Your Door Design</h5>
          <div className="d-flex align-items-center flex-wrap mt-2">
            {NATIVE_DOORS.map((pattern) => (
              <div
                key={pattern.id}
                className="d-grid selected-btn"
                onClick={() =>
                  document.getElementById(`design-${pattern.name}`).click()
                }
                style={{ cursor: "pointer" }}
              >
                <input
                  className="hidden-radio"
                  type="radio"
                  name="design"
                  id={`design-${pattern.name}`}
                  value={pattern.name}
                  checked={selectedDesign === pattern.name}
                  onChange={() => {
                    setSelectedDesign(pattern.name);
                    applyDoorDesign(selectedColor, pattern.name);
                  }}
                  style={{ width: "max-content" }}
                />
                <img
                  src={pattern.img}
                  alt={`pattern-${pattern.name}`}
                  className="img-fluid door-img ms-3"
                />
                <label htmlFor={`design-${pattern.name}`}>
                  {pattern.name.charAt(0).toUpperCase() + pattern.name.slice(1)}
                </label>
              </div>
            ))}
          </div>
        </>
      )}

      {/* Selections Series Panel Styles */}
      {selectSeries === "Selections Series" && (
        <>
          <h5 className="mt-3">Select Your Panel Style</h5>
          <div className="d-flex align-items-center flex-wrap mt-2">
            {PANEL_STYLES.map((pattern) => (
              <div
                key={pattern.id}
                className="d-grid selected-btn"
                onClick={() =>
                  document.getElementById(`panel-${pattern.name}`).click()
                }
                style={{ cursor: "pointer" }}
              >
                <input
                  className="hidden-radio"
                  type="radio"
                  name="panelstyle"
                  id={`panel-${pattern.name}`}
                  value={pattern.name}
                  checked={selectedPanelStyle === pattern.name}
                  onChange={() => handlePanelStyleChange(pattern.name)}
                  style={{ width: "max-content" }}
                />
                <img
                  src={pattern.img}
                  alt={`pattern-${pattern.name}`}
                  className="img-fluid door-img ms-3"
                />
                <label htmlFor={`panel-${pattern.name}`}>
                  {pattern.name.charAt(0).toUpperCase() + pattern.name.slice(1)}
                </label>
              </div>
            ))}
          </div>
        </>
      )}

      {/* Alumicomp Designs */}
      {selectedPanelStyle === "Alumicomp" && (
        <>
          <h5 className="mt-3">Select Your Door Design</h5>
          <div className="d-flex align-items-center flex-wrap mt-2">
            {ALUMICOMP_DESIGNS.map((pattern) => (
              <div
                key={pattern.id}
                className="d-grid selected-btn"
                onClick={() =>
                  document.getElementById(`alumicomp-${pattern.name}`).click()
                }
                style={{ cursor: "pointer" }}
              >
                <input
                  className="hidden-radio"
                  type="radio"
                  name="design"
                  id={`alumicomp-${pattern.name}`}
                  value={pattern.name}
                  checked={selectedDesign === pattern.name}
                  onChange={() => {
                    setSelectedDesign(pattern.name);
                    applyDoorDesign(selectedColor, pattern.name);
                  }}
                  style={{ width: "max-content" }}
                />
                <img
                  src={pattern.img}
                  alt={`pattern-${pattern.name}`}
                  className="img-fluid door-img ms-3"
                />
                <label htmlFor={`alumicomp-${pattern.name}`}>
                  {pattern.name.charAt(0).toUpperCase() + pattern.name.slice(1)}
                </label>
              </div>
            ))}
          </div>
        </>
      )}

      {/* SolidSheet Designs */}
      {selectedPanelStyle === "SolidSheet" && (
        <>
          <h5 className="mt-3">Select Your Door Design</h5>
          <div className="d-flex align-items-center flex-wrap mt-2">
            {SOLID_SHEET_DESIGNS.map((pattern) => (
              <div
                key={pattern.id}
                className="d-grid selected-btn"
                onClick={() =>
                  document.getElementById(`solid-${pattern.name}`).click()
                }
                style={{ cursor: "pointer" }}
              >
                <input
                  className="hidden-radio"
                  type="radio"
                  name="design"
                  id={`solid-${pattern.name}`}
                  value={pattern.name}
                  checked={selectedDesign === pattern.name}
                  onChange={() => {
                    setSelectedDesign(pattern.name);
                    applyDoorDesign(selectedColor, pattern.name);
                  }}
                  style={{ width: "max-content" }}
                />
                <img
                  src={pattern.img}
                  alt={`pattern-${pattern.name}`}
                  className="img-fluid door-img ms-3"
                />
                <label htmlFor={`solid-${pattern.name}`}>
                  {pattern.name.charAt(0).toUpperCase() + pattern.name.slice(1)}
                </label>
              </div>
            ))}
          </div>
        </>
      )}

      {/* Materials for Alumicomp */}
      {selectedPanelStyle === "Alumicomp" && (
        <>
          <h5 className="mt-3">Material</h5>
          <div className="d-flex align-items-center flex-wrap mt-2">
            {MATERIALS.map((pattern) => (
              <div
                key={pattern.id}
                className="d-grid selected-btn"
                onClick={() =>
                  document.getElementById(`material-${pattern.name}`).click()
                }
                style={{ cursor: "pointer" }}
              >
                <input
                  className="hidden-radio"
                  type="radio"
                  name="material"
                  id={`material-${pattern.name}`}
                  value={pattern.name}
                  checked={SelectedMaterial === pattern.name}
                  onChange={() => {
                    setSelectedMaterial(pattern.name);
                    applyDoorDesign(selectedColor, pattern.name);
                  }}
                  style={{ width: "max-content" }}
                />
                <img
                  src={pattern.img}
                  alt={`material-${pattern.name}`}
                  className="img-fluid door-img ms-3"
                />
                <label htmlFor={`material-${pattern.name}`}>
                  {pattern.name.charAt(0).toUpperCase() + pattern.name.slice(1)}
                </label>
              </div>
            ))}
          </div>
        </>
      )}

      {/* SolidSheet Materials */}
      {selectedPanelStyle === "SolidSheet" && (
        <>
          <h5 className="mt-3">Solid Sheet Material</h5>
          <div className="d-flex align-items-center flex-wrap mt-2">
            {SOLID_MATERIALS.map((pattern) => (
              <div
                key={pattern.id}
                className="d-grid selected-btn"
                onClick={() =>
                  document.getElementById(`solidmat-${pattern.name}`).click()
                }
                style={{ cursor: "pointer" }}
              >
                <input
                  className="hidden-radio"
                  type="radio"
                  name="material"
                  id={`solidmat-${pattern.name}`}
                  value={pattern.name}
                  checked={SelectedMaterial === pattern.name}
                  onChange={() => {
                    setSelectedMaterial(pattern.name);
                    applyDoorDesign(selectedColor, pattern.name);
                  }}
                  style={{ width: "max-content" }}
                />
                <img
                  src={pattern.img}
                  alt={`material-${pattern.name}`}
                  className="img-fluid door-img ms-3"
                />
                <label htmlFor={`solidmat-${pattern.name}`}>
                  {pattern.name.charAt(0).toUpperCase() + pattern.name.slice(1)}
                </label>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default DoorOptions;